export default __webpack_public_path__ + "static/media/video.df6635ab.mp4";